import React, { 
    Fragment
} from 'react';

import styled from 'styled-components'


const Input = styled.input`
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;

    :checked + span {
        background-color: #e6e7f7;
        box-shadow: inset 4px 4px 4px 0 rgba(5,15,170,.2);
    }
`

const Span = styled.span`
    width: auto;
    min-width: 120px;
    height: 70px;
    line-height: 1;
    padding: 0 20px;
    color: #050faa;
    background: #fff;
    border: 2px solid #8287d5;
    box-shadow: 4px 4px 4px 0 rgba(5,15,170,.2);
    margin: 0 20px 20px 0;
    text-align: center;
    font-weight: 400;
    transition: all .15s ease-in;
    display: inline-block;

    :before {
        display: inline-block;
        height: 70px;
        content: " ";
        letter-spacing: -.29em;
        vertical-align: middle;
    }

    ${props => props.theme.mediaQueries.medium}{
        min-width: 200px;
    }
`

const Error = styled.p`
    color: ${props => props.theme.codanColors.codanErrorRed};
    font-size: 12px; 
`

const LabelledRadioValidated = ({ 
    labelText, 
    name,
    onChange,
    errors,
    defaultChecked, 
    value,
    values,
    getValue,
}) => {

    const isChecked = () => {
        for(const prop in values) {
            if (prop === name) {
                if (values[name] === value) {
                    return true
                } else {
                    return false
                }           
            }
        }

        if (defaultChecked) {
            return true
        }
    }

    const handleChange = (event) => {
        onChange(event);
        if (getValue !== undefined) {
            getValue(event)
        }
    }

    return (
        <Fragment>
            <label name={name}>
                <Input
                    type='radio'
                    name={name}
                    value={value}
                    onChange={handleChange}
                    checked={isChecked() || false}
                />
                <Span>{labelText}</Span>
            </label>
            {
                errors[name] && (
                    <Error>{errors[name]}</Error>
                )
            }
        </Fragment>

    )
}

export default LabelledRadioValidated